import Icon from '@components/common/Icon';
import {PickList, Show} from '@ultradent/components';
import AddressBookItem from './AddressBookItem';

const HOVER_CLASSES = 'border border-transparent border-solid t-border-color t-duration-short hover:border-sky-blue cursor-pointer';
const ITEMS_CLASSES = 'py-3 px-4 rounded bg-near-white';

const AddressBook = ( {
                          itemIdProp,
                          itemType,
                          groupId,
                          label,
                          addresses,
                          defaultAddress,
                          onAddressChange,
                          allowEdit,
                          error
                      } ) => {

    const isEmpty = !addresses || !addresses.length;

    return (
        <div className="lg:flex flex-wrap items-start w-full justify-between">
            <h2 className="subheading-lg mb-4 lg:w-1/3">{label}</h2>
            {allowEdit
                ? <PickList
                    className="lg:w-2/3"
                    customProps={{error}}
                    defaultSelection={defaultAddress}
                    groupId={groupId}
                    itemIdProp={itemIdProp}
                    itemType={itemType}
                    list={addresses}
                    allowAddItem={false}
                    onItemChange={onAddressChange}>
                    {pickListProps => (
                        <div className="lg:flex">
                            <PickList.EditAction className="lg:w-1/4 inline-block link-3 mb-2 lg:px-4 lg:order-last"/>
                            {isEmpty
                                ? <p className="mt-2 flex items-center lg:w-2/3 font-bold">
                                    <Icon.ui name="report-problem-triangle" className="text-lg mr-2"/>
                                    No addresses available
                                </p>
                                : <div className="lg:w-3/4">
                                    <PickList.Selection
                                        className={ITEMS_CLASSES}
                                        interactionClassName={HOVER_CLASSES}
                                        itemRenderer={AddressBookItem}/>
                                    <PickList.List
                                        enableSearchAtCount={9}
                                        maxResultCount={6}
                                        searchPlaceholder="e.g. 984 Sterling; Dallas TX; 90255"
                                        queryProps={['address1', 'address2', 'city', 'state', 'postalCode']}
                                        itemRenderer={props => <AddressBookItem {...props} className="py-3 px-4"/>}/>
                                    <Show when={pickListProps.error}>
                                        <span className="input-feedback error">{pickListProps.error}</span>
                                    </Show>
                                </div>}
                        </div>
                    )}
                </PickList>
                : <div className="lg:w-2/3">
                    <AddressBookItem {...defaultAddress} className="py-3 px-4"/>
                </div>
            }
        </div>
    );
}

AddressBook.defaultProps = {
    itemIdProp: 'id',
    itemType: 'address',
    groupId: 'addressList',
    label: 'Select address',
    addresses: [],
    defaultAddress: null,
    allowEdit: true,
    onAddressChange: () => {}
}

export default AddressBook;
